import { Link } from "react-router-dom";
import { Mail, Phone, Clock, MapPin } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { PageHeader, Section } from "@/components/blocks";
import { Placeholder } from "@/components/Placeholder";

const ITEMS = [
  { icon: Mail, label: "Email", value: "Business email — coming soon" },
  { icon: Phone, label: "Phone / WhatsApp", value: "Number — coming soon" },
  { icon: Clock, label: "Office hours", value: "Hours — to be confirmed" },
  { icon: MapPin, label: "Location", value: "United Arab Emirates" },
];

export default function Contact() {
  useSeo({
    title: "Contact — Nanny Poppins UAE",
    description:
      "Get in touch with Nanny Poppins. Until our business contact channels are live, please use our request or application forms.",
  });

  return (
    <div>
      <PageHeader
        eyebrow="Contact"
        title="We'd love to hear from you."
        intro="We're finalising our business contact details. In the meantime, the quickest way to reach us is through our forms."
      />

      <Section>
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="grid gap-5 sm:grid-cols-2">
            {ITEMS.map((it) => (
              <div
                key={it.label}
                data-testid={`contact-${it.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="rounded-2xl border border-[#0B0A08]/10 bg-white p-6"
              >
                <it.icon className="h-6 w-6 text-[#C6A04A]" />
                <h3 className="mt-4 text-sm font-semibold uppercase tracking-wider text-[#0B0A08]/60">
                  {it.label}
                </h3>
                <div className="mt-2">
                  {it.label === "Location" ? (
                    <p className="text-[#0B0A08]/80">{it.value}</p>
                  ) : (
                    <Placeholder>{it.value}</Placeholder>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="rounded-2xl bg-[#0B0A08] p-10 text-[#F7F4ED]">
            <h2 className="font-serif text-2xl tracking-tight">Reach us through a form</h2>
            <p className="mt-4 text-[#F7F4ED]/70">
              Whether you're a family looking for care or a nanny hoping to be represented, our forms go
              straight to the team for review.
            </p>
            <div className="mt-8 flex flex-col gap-3">
              <Link
                to="/request-a-nanny-match"
                data-testid="contact-family-cta"
                className="inline-flex items-center justify-center rounded-full bg-[#C6A04A] px-7 py-3.5 text-sm font-semibold text-[#0B0A08] hover:scale-[1.02]"
              >
                Request a Nanny Match
              </Link>
              <Link
                to="/for-nannies"
                data-testid="contact-nanny-cta"
                className="inline-flex items-center justify-center rounded-full border border-[#F7F4ED]/30 px-7 py-3.5 text-sm font-semibold text-[#F7F4ED] hover:border-[#C6A04A] hover:text-[#C6A04A]"
              >
                Apply as a Nanny
              </Link>
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}
